import { useState } from 'react';
import { Lock } from 'lucide-react';
import { AuthLayout } from '../../../components/layouts';
import AuthInput from '../../../components/ui/AuthInput';
import AuthPrimaryButton from '../../../components/ui/AuthPrimaryButton';

const initialValues = {
    oldPassword: '',
    password: '',
    confirmPassword: '',
};

export default function CreateNewPassword() {
    const [formData, setFormData] = useState(initialValues);
    const [loading] = useState(false);
    const [error, setError] = useState(false);

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (formData.password !== formData.confirmPassword) {
            setError(true);
            return;
        }
        setError(false);
    };

    return (
        <AuthLayout>
            <div className="mb-6 text-center">
                <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-ryd-primaryLess1 text-ryd-primary">
                    <Lock size={20} />
                </div>
                <h1 className="font-[AvertaStd-Semibold] text-[22px] text-ryd-headerTextPrimary sm:text-[26px]">
                    Create new password
                </h1>
                <p className="mt-1.5 text-[13px] text-[#8b9aab] sm:text-[14px]">
                    Choose a strong password to secure your account.
                </p>
            </div>

            <form className="space-y-4" onSubmit={handleSubmit}>
                <AuthInput
                    label="Old Password"
                    isPassword
                    placeholder="Enter old password"
                    required
                    leftIcon={<Lock size={18} />}
                    value={formData.oldPassword}
                    onChange={(e) => setFormData({ ...formData, oldPassword: e.target.value })}
                />
                <AuthInput
                    label="New Password"
                    isPassword
                    placeholder="Enter new password"
                    required
                    leftIcon={<Lock size={18} />}
                    value={formData.password}
                    onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                />
                <AuthInput
                    label="Confirm Password"
                    isPassword
                    placeholder="Confirm new password"
                    required
                    leftIcon={<Lock size={18} />}
                    value={formData.confirmPassword}
                    onChange={(e) => setFormData({ ...formData, confirmPassword: e.target.value })}
                />
                {error ? <p className="text-[12px] font-medium text-red-600">Passwords must match!</p> : null}
                <AuthPrimaryButton loading={loading}>Continue</AuthPrimaryButton>
            </form>
        </AuthLayout>
    );
}
